<div
  (click)="onSectionClicked()"
  class="section-wrapper"
  [class.section-wrapper--selectable]="section().sectionId !== null"
  [class.section-wrapper--selected]="sectionFilter()?.sectionIds.includes(section().sectionId)"
  [class.section-wrapper--align-left]="section().alignment === 'left'"
  [class.section-wrapper--align-right]="section().alignment === 'right'"
>
  <div class="section">
    <div
      (click)="onSectionLabelClicked($event)"
      class="section-label"
      [class.section-label--multi-row]="section().segment?.length"
    >
      @if (section().label) {
        <div class="section-initial">{{ section().initial }}</div>
      }

      <div class="section-speaker">
        <span>{{ section().label }}</span>
      </div>

      <div class="section-date">
        {{ section().date | lexDate: 'xiLong12' }}
      </div>

      @if (section().segment) {
        <div class="section-segment-wrapper">
          @for (segment of section().segment; track segment) {
            <span class="section-segment">
              {{ segment }}
            </span>
          }
        </div>
      }
    </div>

    <div class="section-content">
      <div class="section-text-wrapper" [ngClass]="'section-text--speaker-' + (colorIndex() % 10)">
        <div
          class="section-text"
          (click)="onSectionTextClicked()"
          [innerHTML]="section().value"
        ></div>
      </div>
      @if (!isPlaybackDisabled() && section().playbackDisplay) {
        <div (click)="onSectionTextClicked()" class="section-playback-offset">
          {{ section().playbackDisplay }}
        </div>
      }
    </div>
  </div>
</div>
